@if (tokenValid()) {
    <app-header/>

    <div class="container-fluid px-3 px-md-4 py-3">
        <!-- Header Section -->
        <div class="mb-4">
            <h3 class="h4 fw-bold mb-1">Erstellen Sie Ihren Videocall</h3>
            <p class="text-muted small mb-0">Planen Sie einfach Ihren Video Termin!</p>
        </div>

        <!-- Form Card -->
        <div class="card border-0 subtle-shadow mb-4 card-transparent">
            <div class="card-body p-3 p-md-4">
                <form #createForm="ngForm">
                    <!-- Topic -->
                    <div class="mb-3">
                        <label for="topic" class="form-label fw-medium small">Thema des Calls</label>
                        <input id="topic" type="text" class="form-control form-control-sm" [(ngModel)]="room.topic" name="topic"
                               placeholder="zB. Projektbesprechung" required>
                    </div>

                    <!-- Agenda -->
                    <div class="mb-3">
                        <label for="agenda" class="form-label fw-medium small">Agenda (optional)</label>
                        <input id="agenda" type="text" class="form-control form-control-sm" [(ngModel)]="room.agenda" name="agenda"
                               placeholder="Was möchten Sie besprechen">
                    </div>

                    <!-- Date Selection Buttons -->
                    <div class="mb-3">
                        <label class="form-label fw-medium small">Zeitpunkt</label>
                        <div class="btn-group w-100" role="group">
                            <button type="button" class="btn btn-sm" [class.btn-outline-primary]="showDate()"
                                    [class.btn-primary]="!showDate()" (click)="setDate('now')">
                                <i class="fas fa-play"></i>
                                <span class="d-none d-sm-inline ms-1">Sofort starten</span>
                                <span class="d-inline d-sm-none ms-1">Sofort</span>
                            </button>
                            <button type="button" class="btn btn-sm" [class.btn-outline-primary]="!showDate()"
                                    [class.btn-primary]="showDate()" (click)="setDate('custom')">
                                <i class="fas fa-clock"></i>
                                <span class="d-none d-sm-inline ms-1">Zeitpunkt wählen</span>
                                <span class="d-inline d-sm-none ms-1">Zeitpunkt</span>
                            </button>
                        </div>
                    </div>

                    <!-- Date Picker -->
                    @if (showDate()) {
                        <div class="mb-3">
                            <label for="date" class="form-label fw-medium small">Datum und Uhrzeit</label>
                            <input id="date" type="datetime-local" class="form-control form-control-sm" [(ngModel)]="room.date" name="date"
                                   required>
                        </div>
                    }

                    <!-- Creator Name -->
                    <div class="mb-3">
                        <label for="creator" class="form-label fw-medium small">Ihr Name</label>
                        <input id="creator" type="text" class="form-control form-control-sm" [(ngModel)]="room.creator" name="creator"
                               placeholder="Max Mustermann" required>
                    </div>

                    <!-- Participants -->
                    <div class="mb-3">
                        <label class="form-label fw-medium small">Teilnehmer</label>
                        @for (participant of room.participants; track $index) {
                            <div class="input-group input-group-sm mb-2">
                                <input type="text" class="form-control" [(ngModel)]="room.participants[$index]"
                                       [name]="'participant-' + $index"
                                       placeholder="E-Mail oder Telefonnummer" required>
                                <button type="button" class="btn btn-outline-danger" (click)="removeParticipant($index)" aria-label="Teilnehmer entfernen">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        }

                        @if (room.participants.length === 0) {
                            <div class="text-danger small mb-2">Bitte Teilnehmer hinzufügen</div>
                        }

                        <div class="d-grid gap-2">
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addParticipant()">
                                <i class="fas fa-plus-circle"></i>
                                Manuell hinzufügen
                            </button>
                            @if (contactPickerAvailable()) {
                                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="getContacts()">
                                    <i class="fas fa-user-plus"></i>
                                    Aus Kontakten hinzufügen
                                </button>
                            }
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openLastContactsModal()">
                                <i class="fas fa-user-friends"></i>
                                Aus letzten Kontakten hinzufügen
                            </button>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <div class="d-grid mt-4">
                        <button type="button" class="btn btn-primary" (click)="create()" [disabled]="!createForm.valid || room.participants.length === 0 || loading()">
                            <i class="fas fa-video me-1"></i>
                            @if (loading()) {
                                <i class="fas fa-spinner fa-spin me-1"></i>
                            }
                            Video Call erstellen
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
} @else {
    <div class="container-fluid px-3 py-5 text-center">
        <div class="alert alert-danger">Invalid token</div>
    </div>
}

<!-- Last Contacts Modal -->
<ng-template #lastContactsModal>
    <div class="modal-header">
        <h5 class="modal-title">Letzte Kontakte</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
        @if (lastContacts().length === 0) {
            <div class="text-muted text-center py-4">
                <i class="fas fa-inbox fa-2x mb-2"></i>
                <p>Keine letzten Kontakte verfügbar</p>
            </div>
        } @else {
            <div class="list-group">
                @for (contact of lastContacts(); track $index) {
                    <div class="list-group-item d-flex justify-content-between align-items-center">
                        <button type="button" class="btn btn-link text-start flex-grow-1 text-decoration-none p-0"
                                (click)="selectContact(contact)">
                            <i class="fas fa-user me-2"></i>
                            {{ contact }}
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger ms-2"
                                (click)="removeLastContact($index)"
                                aria-label="Kontakt entfernen">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                }
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Schließen</button>
    </div>
</ng-template>
